import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/Home',
    name: 'Home',
    component: Home,
    redirect: '/Home/Store',
    children: [
      {
        path: 'Store',
        name: 'Store',
        component: () => import(/* webpackChunkName: "about" */ '../views/Store.vue')
      },
      {
        path: 'PointDeduction',
        name: 'PointDeduction',
        component: () => import(/* webpackChunkName: "about" */ '../views/PointDeduction.vue')
      },
      {
        path: 'Recharge',
        name: 'Recharge',
        component: () => import(/* webpackChunkName: "about" */ '../views/Recharge.vue')
      },
      {
        path: 'OperationsStatistics',
        name: 'OperationsStatistics',
        component: () => import(/* webpackChunkName: "about" */ '../views/OperationsStatistics.vue')
      },
      {
        path: 'StoreOperationsChart',
        name: 'StoreOperationsChart',
        component: () => import(/* webpackChunkName: "about" */ '../views/StoreOperationsChart.vue')
      },
      {
        path: 'GameOperationsAnalysis',
        name: 'GameOperationsAnalysis',
        component: () => import(/* webpackChunkName: "about" */ '../views/GameOperationsAnalysis.vue')
      }
    ],
  },
  {
    path: '/Login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue'),
    meta: {
      needLogin: false, // 是否需要登录，没有或者为true表示需要
    }
  },
  {
    path: '/pay',
    name: 'pay',
    component: () => import(/* webpackChunkName: "about" */ '../views/pay.vue'),
    meta: {
      needLogin: false, // 是否需要登录，没有或者为true表示需要
    }
  },
  {
      path: '*', // 除了已经被配置过的路由 其余全部重定向到 /Login
      redirect: '/Login',
  },
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由校验是否需要登录
router.beforeEach((to, from, next) => {
  if (to.name == 'Login'||to.name == 'pay') {
    next();
  } else {
    if (localStorage.getItem('token')) {
      next();
    } else {
      router.replace({name: 'Login'})
    }
  }
})

export default router
